/**
 * Auth Actions
 */
import { SIGNIN, SIGNOUT } from '../constants';

/**
 * Sign In
 * JWT token is already stored in localStorage by the Login component
 */
export const signIn = () => (async (dispatch) => {
  try {
    dispatch({ type: SIGNIN.SIGNIN_SUCCESS });
  } catch (err) {
    throw new Error(err.message);
  }
});

/**
 * Sign Out
 * Clear JWT token from localStorage
 */
export const signOut = () => (async (dispatch) => {
  try {
    // Remove token from localStorage
    localStorage.removeItem('authToken');
    localStorage.removeItem('rememberMe');
    dispatch({ type: SIGNOUT.SIGNOUT_SUCCESS });
  } catch (err) {
    throw new Error(err.message);
  }
});
